/* cf-latch-colour-fix.js — glass calculator: every gate latch PART follows the hardware colour.
   Approved by Pete 4 Oct 2026. _calcSectionQuote and _buildCartItemsForSection matched the latch colour
   exactly ('black' against 'Matte Black'), so Matte Black / Matte White latches fell back to the Mirror
   variant of the same position. This keeps the calculator's position and swaps in the section's colour.
   Idempotent; any error leaves the calculator's own line. */
(function () {
  var tries = 0;
  function ck(c) { c = String(c || '').toLowerCase(); return c.indexOf('white') > -1 ? 'white' : c.indexOf('black') > -1 ? 'black' : 'mirror'; }
  function pk(p) { return String(p || '').toLowerCase().replace(/[-_]+/g, ' ').replace(/\s+/g, ' ').trim(); }
  function variants(gc) { var g = gc.shopifyData && gc.shopifyData.products && gc.shopifyData.products.gateLatch; return (g && g.variants) || []; }
  function colourOf(gc, s) { var f = {}; try { f = gc.resolveSectionFinish(s) || {}; } catch (e) {} return ck(f.hingeLatchColour || (s && s.latchColor) || 'mirror'); }
  function swap(gc, id, col) {
    var vs = variants(gc), cur = vs.find(function (v) { return String(v.id) === String(id); });
    if (!cur || ck(cur.color) === col) return null;
    return vs.find(function (v) { return v.available && pk(v.position) === pk(cur.position) && ck(v.color) === col; }) || null;
  }
  function install() {
    var gc = window.glassCalculator;
    if (!gc || !gc.shopifyData || typeof gc._calcSectionQuote !== 'function') return false;
    var P = Object.getPrototypeOf(gc);
    if (P.__cfLatchColourPatched) return true;
    var oQ = P._calcSectionQuote;
    P._calcSectionQuote = function (n, section) {
      var res = oQ.apply(this, arguments);
      try {
        var col = colourOf(this, section), self = this;
        ((res && res.breakdown) || []).forEach(function (l) {
          if (!l || !/^Gate Latch/.test(l.item || '') || !l.variantId) return;
          var nv = swap(self, l.variantId, col); if (!nv) return;
          var np = nv.price / 100, q = l.quantity || 1;
          res.subtotal = (res.subtotal || 0) + np * q - (l.totalPrice || 0);
          l.variantId = nv.id; l.unitPrice = np; l.totalPrice = np * q;
          if (l.sku != null) l.sku = nv.sku || null;
        });
      } catch (e) { try { console.warn('[cf-latch-colour-fix]', e); } catch (_) {} }
      return res;
    };
    var oC = P._buildCartItemsForSection;
    if (typeof oC === 'function') P._buildCartItemsForSection = function (section) {
      var st = (this.state && this.state.cartItems) ? this.state.cartItems.length : 0;
      var r = oC.apply(this, arguments);
      try {
        var col = colourOf(this, section), self = this;
        (this.state.cartItems || []).slice(st).forEach(function (it) {
          if (!/^Gate Latch/.test(it.title || '')) return;
          var nv = swap(self, it.variantId, col); if (nv) it.variantId = nv.id;
        });
      } catch (e) {}
      return r;
    };
    P.__cfLatchColourPatched = true;
    try { console.log('[cf-latch-colour-fix] installed'); } catch (_) {}
    return true;
  }
  (function poll() { if (install() || ++tries > 200) return; setTimeout(poll, 100); })();
})();
